export type LedTone = 'off' | 'on' | 'warn' | 'error';

/**
 * Small LED-style status indicator with optional pulse for "live" states.
 */
export class StatusLed {
  readonly el: HTMLSpanElement;
  private tone: LedTone = 'off';

  constructor(initial: LedTone = 'off') {
    this.el = document.createElement('span');
    this.el.className = 'status-led';
    this.set(initial);
  }

  set(tone: LedTone, pulse = false): void {
    this.tone = tone;
    this.el.dataset.tone = tone;
    this.el.classList.toggle('is-pulsing', pulse && tone !== 'off');
  }

  get(): LedTone {
    return this.tone;
  }
}
